export const PROHIBITED_ITEMS = {
  asbestos: ["asbestos"],
  paintOrPaintCans: ["paint", "paint can", "paint cans"],
  liquidChemicalsOrSolvents: ["chemical", "solvent", "solvents"],
  carBatteries: ["car battery", "car batteries"],
  rawMeatOrInPackaging: ["meat"],
  clinicalOrBiologicalWaste: ["clinical waste", "biological waste"],
  fireExtinguishers: ["fire extinguisher", "fire extinguishers"],
  gasBottles: ["gas bottle", "gas bottles"],
  oilsOrPetrol: ["oil", "oils", "petrol", "diesel", "fuel"],
} as const;
